<template>
  <div class="el-card pd20">
    
    <div class="main">
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100" label="序号"></el-table-column>
           <el-table-column prop="id" width="100" label="活动ID"></el-table-column>
          <el-table-column prop="name" label="活动名称"></el-table-column>
        
          <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                  <el-button type="primary" size="mini"  @click="editHandle(scope.$index, scope.row)" >编辑</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus" @click="addActivity()"  circle></el-button>
      <!-- 分页 -->
      <el-pagination class="pages" 
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pages.size" 
        :current-page="pages.page"
        background 
        layout="sizes,prev, pager, next" 
        :total="pages.count"> 
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog title="活动编辑" :visible.sync="bool">
      <el-form :model="form">
        <el-form-item label="活动名称" >
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bool = false">取 消</el-button>
        <el-button type="primary" @click="saveActivity()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { activityList,getActivity,addActivity,updateActivity  } from "@/api/operating";

export default {
    data() {
        return{
            list: [],
            pages:{},
            form:{
              name:''
            },
            bool:false
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 添加活动
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020年5月28日
        */
        addActivity(){
          this.form = {
            name:''
          };
          this.bool= true;
        },
        /*
         *@param: 
         *@return: 
         *@Description: 确定要失效试用链接吗
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 13:26:26
        */
        saveActivity(){
          if(this.form.id){
            updateActivity(this.form).then(data=>{
              if(data.error >0){
                  this.$message(data.msg);
                  return;
              }
              this.$notify({
                  title: '成功',
                  message: '修改成功！',
                  type: 'success'
              });
            });
          }else{
            addActivity(this.form).then(data=>{
              if(data.error >0){
                  this.$message(data.msg);
                  return;
              }
              this.$notify({
                  title: '成功',
                  message: '添加成功！',
                  type: 'success'
              });
            });
          }
          this.bool = false;
          this.$forceUpdate();
          this.pullData();
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 修改
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020年5月28日
        */
        editHandle(index,row){
            this.form = row;
            this.bool = true;
            
        },
        
        // 初始化获取数据
        pullData(){
            this.$showLoading();
            let obj = {
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null,   //每页数量，默认25
            };

            activityList(obj).then((data)=>{
              if(data.error >0){
                  this.$message(data.msg);
                  return false;
              }
                this.list = data.list;
                this.pages = data.pager;
                
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
    
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content:center;
    img{
        width: 80px;
        border-radius: 10px;
        margin-right: 15px;
    }
}
.search{
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .search-child{
        display: flex;
        align-items: center;
        flex:1;
        label{
            font-size: 16px;
            color: #606266;
        }
        .input{
            width: 200px;
        }
        .btn{
            margin-left: auto;
        }
    }
    .search-child.on{
        flex:1.5;
    }
    
}
</style>
